// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"SideNav_cursorPointer__1C1iS","userimg":"SideNav_userimg__2H_Hz"};